var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddComponenticon = function SvgAddComponenticon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.902 2.717v.608a.4.4 0 0 1-.4.4h-1.296v1.296a.4.4 0 0 1-.4.4h-.608a.4.4 0 0 1-.4-.4V3.725h-1.296a.4.4 0 0 1-.4-.4v-.608a.4.4 0 0 1 .4-.4h1.296V1.021a.4.4 0 0 1 .4-.4h.608a.4.4 0 0 1 .4.4v1.296h1.296a.4.4 0 0 1 .4.4Zm-8.617.612a.64.64 0 0 0-1 .335L5.59 6.092a3.2 3.2 0 0 1-2.198 2.199l-2.43.693a.64.64 0 0 0 0 1.231l2.43.694a3.2 3.2 0 0 1 2.198 2.198l.694 2.429a.64.64 0 0 0 1.23 0l.694-2.429a3.2 3.2 0 0 1 2.199-2.198l2.428-.694a.64.64 0 0 0 0-1.23l-2.428-.694s-1-.43-1.385-.815a3.2 3.2 0 0 1-.814-1.384l-.694-2.428a.64.64 0 0 0-.23-.335Z",
    clipRule: "evenodd"
  })));
};
export default SvgAddComponenticon;